import { createFileRoute } from "@tanstack/react-router";
import { RewardsIdlePage } from "../../features/rewards/pages/rewards-idle-page";

export const Route = createFileRoute("/_layout/rewards/idle")({
  component: RewardsIdlePage,
});
